import { ListItemText, styled } from '@mui/material';
var MenuItemText = styled(ListItemText)({
    marginTop: 0,
    marginBottom: 0,
});
export default MenuItemText;
